import React from 'react';

export type DeviceOrientationType = 'landscape' | 'portrait';
// In JS, run on load and on resize:
function setRealVh() {
  document.documentElement.style.setProperty(
    '--mfw-window-height',
    `${window.innerHeight}px`,
  );
}

function convertOrientationType(
  orientation: OrientationType,
): DeviceOrientationType {
  if (orientation.indexOf('landscape') !== -1) {
    return 'landscape';
  }
  return 'portrait';
}

export function useDeviceOrientation() {
  const [isFixedAppLayoutContent, setFixedAppLayoutContent] =
    React.useState<boolean>(false);
  const [deviceOrientation, setDeviceOrientation] =
    React.useState<DeviceOrientationType>(
      screen.orientation.type
        ? convertOrientationType(screen.orientation.type)
        : 'portrait',
    );
  React.useEffect(() => {
    function onResize() {
      if (window.innerHeight > window.innerWidth) {
        setDeviceOrientation('portrait');
      } else {
        setDeviceOrientation('landscape');
      }
    }

    function onOrientationChange() {
      setDeviceOrientation(
        convertOrientationType(screen.orientation.type || 'portrait-primary'),
      );
    }

    onResize();
    window.addEventListener('resize', onResize);
    screen.orientation.addEventListener('change', onOrientationChange);

    return () => {
      window.removeEventListener('resize', onResize);
      screen.orientation.removeEventListener('change', onOrientationChange);
    };
  }, []);

  React.useEffect(() => {
    setRealVh();
    window.addEventListener('resize', setRealVh);
    return () => {
      window.removeEventListener('resize', setRealVh);
    };
  }, []);

  return {
    deviceOrientation,
    isFixedAppLayoutContent,
    setFixedAppLayoutContent,
  };
}
